/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { createAsyncThunk } from '@reduxjs/toolkit';
import { matchPath } from 'react-router-dom';
import { keycloakService } from './auth.service';
import { RoutePath } from '../../../shared/enums/RoutePath';
import draftApi from '../../../api/draft.api';

/**
 * Thunks that use createAsyncThunk because they are being called at the first load of the application.
 * These thunks should rarely fail, and when they do, the fail will be handled via auth.slice.
 */
export const postSignInThunk = createAsyncThunk('auth/signIn', async options => keycloakService.login(options));

/**
 * Thunks that use createAsyncThunk because they are being called at the first load of the application.
 * These thunks should rarely fail, and when they do, the fail will be handled via auth.slice.
 */
export const postSignOutThunk = createAsyncThunk('auth/signOut', async (postLogoutRedirectUri) => {
  const match = matchPath(window.location.pathname, RoutePath.getRoutePath(window.location.pathname).path);
  if (match?.params?.submissionId) await draftApi.unlockById(match.params.submissionId);
  return keycloakService.logout(postLogoutRedirectUri);
});
